import { render, staticRenderFns } from "./HeroWorkbench.vue?vue&type=template&id=44ba3bee&scoped=true&"
import script from "./HeroWorkbench.vue?vue&type=script&lang=js&"
export * from "./HeroWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./HeroWorkbench.vue?vue&type=style&index=0&id=44ba3bee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba3bee",
  null
  
)

export default component.exports